import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/generated/IconTimeWarningFill.tsx
const IconTimeWarningFill = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 32 32",
	"aria-hidden": "true",
	"data-slot": "icon",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ jsxs("g", {
		fill: "currentColor",
		children: [/* @__PURE__ */ jsx("path", {
			fillRule: "evenodd",
			d: "M17.333 24.555a8.5 8.5 0 0 0 .659 3.298 13.5 13.5 0 0 1-2.48.139c-7.138-.257-12.845-6.125-12.845-13.325C2.667 7.303 8.636 1.334 16 1.334c7.2 0 13.067 5.707 13.325 12.845a13.7 13.7 0 0 1-.14 2.479 8.5 8.5 0 0 0-3.296-.659 8.53 8.53 0 0 0-4.59 1.335 8.55 8.55 0 0 0-3.966 7.221m4.078-9.888a11 11 0 0 0-3.61 2.667h-3.134V8h2.666v6.667z",
			clipRule: "evenodd"
		}), /* @__PURE__ */ jsx("path", { d: "M25.889 30.666q.63-.001 1.223-.122v-2.1h-2.445v2.1q.593.121 1.222.122M24.667 26h2.444v-7.434a6.15 6.15 0 0 0-2.444 0z" })]
	})]
});
var IconTimeWarningFill_default = forwardRef(IconTimeWarningFill);
//#endregion
export { IconTimeWarningFill_default as default };
